export function Base() {
  return (
    <svg
      width="1342"
      height="502"
      viewBox="0 0 1342 502"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute top-0 left-0 [pointer-events:none]"
    >
      <path
        d="M1 293V251V209C1 164.823 17.8742 74.1686 60 32C90.9683 1.00009 151.456 1.00168 170.769 1.00219L171 1.0022L1110 1C1169.03 2.31077 1253.14 13.8419 1296 40C1337.12 65.1003 1341 144.763 1341 204V251V298C1341 357.237 1337.12 436.9 1296 462C1253.14 488.158 1169.03 499.689 1110 501L171 500.998H170.769C151.457 500.998 90.9684 501 60 470C17.8742 427.831 1 337.177 1 293Z"
        fill="currentColor"
        className="text-car-floor [pointer-events:fill]"
      />
      <path
        d="M1 293V251V209C1 164.823 17.8742 74.1686 60 32C90.9683 1.00009 151.456 1.00168 170.769 1.00219L171 1.0022L1110 1C1169.03 2.31077 1253.14 13.8419 1296 40C1337.12 65.1003 1341 144.763 1341 204V251V298C1341 357.237 1337.12 436.9 1296 462C1253.14 488.158 1169.03 499.689 1110 501L171 500.998H170.769C151.457 500.998 90.9684 501 60 470C17.8742 427.831 1 337.177 1 293Z"
        stroke="currentColor"
        strokeWidth="2"
        className="text-car-stroke"
      />
    </svg>
  );
}
